import React from 'react';
import '../assets/scss/components/overlay.scss';

const Overlay = ({ visible, onClick }) => {
    const handleOnClick = () => {
        onClick();
    };

    return (
        <div className={`overlay ${visible ? 'visible' : ''}`} onClick={handleOnClick}></div>
    );
};

export default Overlay;
